export default __webpack_public_path__ + "src/assets/icn-receive.a3370eba464366369fa3c8e8788f4a89.svg";